import React, { useState } from 'react';
import SimpleLoader from 'components/loader/SimpleLoader';
import useNotifications from '../hooks/useNotifications';
import NotificationCard from 'components/card/NotificationCard';
import { NotificationItem } from 'types/Notification';
import PaginationComponent from 'components/pager/Pagination';
import { FormatDate, FormatHours } from 'components/dates/FormatDate';
import { Switch } from '@mui/material';
import InfoStateNotifications from './InfoStateNotifications';

const NotificationList = () => {
    const { items, loading, error, filter, setFilter, markAllAsRead } =
        useNotifications();
    const [showUnread, setShowUnread] = useState<boolean>(false);

    // Function to get the date difference in days
    function getDateDifferenceInDays(date: Date): number {
        const now = new Date();
        const diffInMs = now.getTime() - date.getTime();
        return Math.floor(diffInMs / (1000 * 60 * 60 * 24));
    }

    function separateNotificationsByDate(notifications: NotificationItem[]) {
        const today: NotificationItem[] = [];
        const yesterday: NotificationItem[] = [];
        const last7Days: NotificationItem[] = [];
        const thisMonth: NotificationItem[] = [];
        const thisYear: NotificationItem[] = [];
        const earlier: NotificationItem[] = [];

        const now = new Date();

        notifications.forEach((notification) => {
            const formatedDate = FormatDate(notification.created);
            const createdDate = new Date(formatedDate);
            const daysDifference = getDateDifferenceInDays(createdDate);

            if (createdDate.toDateString() === now.toDateString()) {
                today.push(notification);
            } else if (daysDifference === 1) {
                yesterday.push(notification);
            } else if (daysDifference <= 7) {
                last7Days.push(notification);
            } else if (
                createdDate.getMonth() === now.getMonth() &&
                createdDate.getFullYear() === now.getFullYear()
            ) {
                thisMonth.push(notification);
            } else if (createdDate.getFullYear() === now.getFullYear()) {
                thisYear.push(notification);
            } else {
                earlier.push(notification);
            }
        });

        const datesWithTitles = [
            { title: 'Earlier', notifications: earlier },
            { title: 'Today', notifications: today },
            { title: 'Yesterday', notifications: yesterday },
            { title: 'Last 7 days', notifications: last7Days },
            { title: 'This Month', notifications: thisMonth },
            { title: 'This Year', notifications: thisYear },
        ].filter((entry) => entry.notifications.length > 0);

        return datesWithTitles;
    }

    const separatedNotifications = separateNotificationsByDate(items.nodes);

    const handleSwitchUnread = () => {
        setShowUnread(!showUnread);
        setFilter({ ...filter, unread: !showUnread });
    };

    const NotificationFilters = () => {
        return (
            <div className="flex justify-end space-x-24 items-center">
                <p
                    className="text-sea-blue-600 underline cursor-pointer"
                    onClick={markAllAsRead}
                >
                    Mark all as read
                </p>
                <div className="flex items-center">
                    <p className="text-true-blue">
                        {showUnread ? 'All' : 'Unread'}
                    </p>
                    <Switch
                        checked={showUnread}
                        onChange={handleSwitchUnread}
                    />
                </div>
            </div>
        );
    };

    return (
        <div className="col-span-2 mt-1.5">
            {loading ? (
                <SimpleLoader />
            ) : error || items.nodes.length === 0 ? (
                <div>
                    <div className="flex justify-between ">
                        <p className="notification-section-title">Today</p>
                        <NotificationFilters />
                    </div>
                    <InfoStateNotifications error={error} />
                </div>
            ) : (
                <div>
                    {separatedNotifications.map((arrayDate, index) => (
                        <div
                            className="flex flex-col space-y-12"
                            key={`notification-section-${index}`}
                        >
                            <div className="flex justify-between">
                                <p className="notification-section-title">
                                    {arrayDate.title}
                                </p>
                                {index === 0 && <NotificationFilters />}
                            </div>
                            {arrayDate.notifications.map((item, innerIndex) => (
                                <NotificationCard
                                    {...item}
                                    created={
                                        [
                                            'Today',
                                            'Yesterday',
                                            'Earlier',
                                        ].includes(arrayDate.title)
                                            ? FormatHours(item.created)
                                            : `${FormatDate(item.created)}  ${FormatHours(item.created)}`
                                    }
                                    key={`notification-${index}-${innerIndex}`}
                                />
                            ))}
                        </div>
                    ))}
                    <PaginationComponent
                        items={items}
                        filter={filter}
                        setFilter={setFilter}
                    />
                </div>
            )}
        </div>
    );
};

export default NotificationList;
